import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/folder`;
const readUrl = (url = "") => `${urlBase}/${url}`;

export const postFolder = async (folderData) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(``), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(folderData),
  });

  res = await parseJSON(res);

  return res.success;
};

export const fetchFolderById = async ({ entityId }) => {
  let url = "";
  const auth = `Bearer ${getToken()}`;
  if (entityId) {
    url = readUrl(`${entityId}`);
  } else {
    url = readUrl(``);
  }
  let res = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const patchFolder = async ({ entityId, folderData }) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`${entityId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(folderData),
  });

  res = await parseJSON(res);

  return res.success;
};

export const getPisPermisoCarpeta = async ({ entityId }) => {
  let url;
  const auth = `Bearer ${getToken()}`;
  if (entityId) {
    url = readUrl(`pi_asignable/${entityId}`);
  } else {
    url = readUrl(`pi_asignable`);
  }
  let res = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const sharedFolder = async ({ folderId, piId }) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`${folderId}/share/${piId}`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const deleteSharedFolder = async ({ folderId, piId }) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`${folderId}/share/${piId}`), {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const generateShareLink = async ({ folderId }) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`${folderId}/share/link`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};
